// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__Ic1SS","tabPrimary":"Tabs_tabPrimary__xo-EL","tabSelected":"Tabs_tabSelected__eK8Pw"};